module.exports = "<div class=\"scrollable\">\n  <div class=\"scrollable-content home\">\n    <div class=\"list-group text-center\">\n      <div class=\"list-group-item-home\">\n        <div>\n          <i class=\"fa fa-check  feature-icon text-primary\"></i>\n        </div>\n        <div>\n          <h3 class=\"home-heading\">Help</h3>\n          <p>Call us</p>\n          <hr />\n        </div>\n      </div>\n    </div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/help/help.component.html
// module id = ../../../../../src/app/help/help.component.html
// module chunks = main